export const state = {
    altImage: 'https://picsum.photos/400?grayscale&blur=2',
}

export const getters = {
    altImage: state => state.altImage,
}
